<template lang="pug">
div
  .is-hidden-tablet-only.is-hidden-desktop-only.is-hidden-widescreen-only.is-hidden-fullhd
    br
    .feature-helvetica.fs-18
      span  Our 
      span.w400 Guided Setup
      span  is a tool for using well known third party mining apps with our platform.
    hr
  .step-title
    span Select your setup mode
  .columns
    .column(v-for="o in modes")
      .box-container.is-flex.fdc.jcc.aic
        .element-box-container.text-only(@click="select(o.code)")
          span.name {{ o.name }}
        .box-explanation
          span {{ o.description }}
</template>

<script>
export default {
  name: 'c_step_mode',
  data () {
    return {
      modes: [
        {
          'code': 'basic',
          'name': 'Basic',
          'icon': 'fa-smile-o',
          'description': 'Continue with our Basic mode, only 6 steps to go'
        },
        {
          'code': 'advanced',
          'name': 'Advanced',
          'icon': 'fa-frown-o',
          'description': `Select Advanced if you want to specify the region server, port and worker name`
        }
      ]
    }
  },
  mounted () {
    document.getElementById('step').scrollIntoView();
  },
  methods : {
    select (code) {
      let vm = this
      vm.$emit('selected', code)
    }
  }
}
</script>

<style lang="stylus" scoped>
@media (max-width: 768px)
  .step-explanation
    margin-bottom 20px
  .box-container
    margin-top 0px
</style>



// WEBPACK FOOTER //
// c_step_mode.vue?7e826884